module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kansai-3-fc26835daeee3e242a12b2c702ad8b77.png";